var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-layout"},[_c('div',{staticClass:"auth-layout__wrapper"},[(!_vm.hideLogo)?_c('div',{staticClass:"auth-layout__logo"},[_c('v-logo',{staticClass:"auth-layout__logo-image"})],1):_vm._e(),_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }